


interface MetaData {
    title: string;
    description: string;
    robots?: string;
    canonical?: string;
    og?: {
        locale?: string,
        type?: string,
        title?: string,
        description?: string,
        url?: string,
        site_name?: string,
        updated_time?: string,
        image?: string,
        image_secure_url?: string,
        image_width?: number,
        image_height?: number,
        image_alt?: string,
        image_type?: string,
        video?: string,
        video_duration?: number,
        video_upload_date?: string,
        video_allow_embed?: boolean,
    };
    twitter?: {
        card?: string,
        title?: string,
        description?: string,
        image?: string,
    };
}

interface Step {
    title: string;
    desc: string;
    icon: string;
}

interface ProcedureSteps {
    heading: string;
    para: string;
    steps: Step[];
}

interface ListItem {
    title: string;
    desc: string;
    icon: string;
}

interface ListSection {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface ingredients {
    heading?: string;
    subheading?: string;
    para?: string;
    items: ListItem[];
}

interface FAQItem {
    question: string;
    answer: string;
}

interface FAQSection {
    heading?: string;
    subheading?: string;
    items: FAQItem[];
}

interface HeroSection {
    title: string;
    subtitle: string;
    description: string;
}

interface HowItWorks {
    title: string;
    description: string;
}

interface TreatmentArea {
    ar: string;
    title: string;
    image: string;
}

interface LanguageContent {
    url?: string; // Added url property
    meta: MetaData;
    breadcrumbs: string[];
    hero: HeroSection;
    howItWorks: HowItWorks;
    procedureSteps: ProcedureSteps;
    benefits: ListSection;
    eligibility: ListSection;
    preparationTips: ListSection;
    results: ListSection;
    aftercareTips: ListSection;
    faqData: FAQSection;
    // ingredients: ingredients;
    // treatmentAreas1: TreatmentArea[];
    // treatmentAreas2: TreatmentArea[];
}

interface SharedData {
    images: {
        main: string,
        beforeAfter: string[] | any,
        introductionImage?: string,
    };
    product: {
        id: number,
        title: string,
        price: number,
        description: string,
    };
}

export const powershape: {
    en: LanguageContent,
    ar: LanguageContent,
    shared: SharedData,
} =
{
    "en": {
        "url": "powershape-body-contouring",
        "meta": {
            "title": "PowerShape Body Contouring in Dubai | Elite Body Home",
            "description": "PowerShape is a revolutionary non-invasive treatment that combines multiple technologies to smooth cellulite, tighten skin, and reduce fat deposits for enhanced body contours.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/powershape-body-contouring/",
            "og": {
                "title": "PowerShape Body Contouring in Dubai | Elite Body Home",
                "description": "Non-invasive body sculpting treatment combining RF, vacuum massage and foam therapy for fat reduction and skin tightening",
                "image": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/Elite-Body-Home-Services-for-Astatic-Clinic-in-Dubai-50.jpg"
            }
        },
        "breadcrumbs": ["Home", "Services", "PowerShape Body Contouring"],
        "hero": {
            "title": "PowerShape Body Contouring in Dubai",
            "subtitle": "Triple-Technology Body Sculpting",
            "description": "PowerShape is a one-of-a-kind service that can shape and sculpt the body when combined with multiple concerns in one visit. This synergistic approach works simultaneously to smooth cellulite, tighten skin, and reduce fat deposits. This painless and non-invasive treatment is suitable for all skin types and delivers long-lasting results making this a go-to for enhancing body contours."
        },
        "howItWorks": {
            "title": "How Does PowerShape Work?",
            "description": "PowerShape incorporates triple cutting-edge technologies to deliver comprehensive body contouring results without surgery or downtime."
        },
        "procedureSteps": {
            "heading": "Treatment Process",
            "para": "Your PowerShape experience follows this streamlined process:",
            "steps": [
                {
                    "title": "Consultation",
                    "desc": "Your journey begins with a full consultation where we assess your body shape and discuss your concerns to create a customized treatment plan.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "Radiofrequency Application",
                    "desc": "RF energy heats deep tissue layers to stimulate collagen production and destroy fat cells.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "Vacuum Massage",
                    "desc": "Specialized suction improves circulation, boosts lymphatic drainage and reduces cellulite appearance.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "Foam Therapy",
                    "desc": "Air bubble technology breaks down fat cells for natural elimination from the body.",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "Post-Treatment Care",
                    "desc": "Soothing products are applied to nourish and revitalize the treated area.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "Benefits of PowerShape",
            "subheading": "Comprehensive body sculpting without surgery",
            "para": "PowerShape offers multiple advantages for those seeking non-surgical body contouring:",
            "items": [
                {
                    "title": "Fat Reduction",
                    "desc": "Targets stubborn fat deposits in areas like abdomen, thighs, arms and buttocks.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Cellulite Improvement",
                    "desc": "Reduces the appearance of orange-peel skin by breaking down adipose tissues.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Skin Tightening",
                    "desc": "Stimulates collagen and elastin production for firmer, more youthful skin.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "Improved Circulation",
                    "desc": "Vacuum massage enhances blood flow and lymphatic drainage.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "Non-Invasive",
                    "desc": "No surgery, needles or downtime required.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "Quick Sessions",
                    "desc": "Treatments take just 30-60 minutes with no recovery time needed.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "Who is a Good Candidate for PowerShape?",
            "subheading": "",
            "para": "PowerShape is ideal for individuals who want to improve body contours without surgery. The best candidates include:",
            "items": [
                {
                    "title": "Healthy Adults",
                    "desc": "Those with realistic expectations about non-surgical body contouring.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "Mild to Moderate Fat",
                    "desc": "People with localized fat deposits that resist diet and exercise.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "Cellulite Concerns",
                    "desc": "Individuals wanting to reduce the appearance of cellulite.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "Skin Laxity",
                    "desc": "Those seeking mild to moderate skin tightening.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "All Skin Types",
                    "desc": "Safe and effective for all skin tones and types.",
                    "icon": "fa-solid fa-users"
                }
            ]
        },
        "preparationTips": {
            "heading": "Preparing for Your PowerShape Session",
            "subheading": "",
            "para": "To optimize your PowerShape treatment results:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Drink plenty of water before your appointment to support lymphatic drainage.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Eat Light",
                    "desc": "Have a light, healthy meal before your session for comfort.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "Wear Comfortable Clothing",
                    "desc": "Choose loose-fitting clothes for easy access to treatment areas.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "Avoid Sun Exposure",
                    "desc": "Protect your skin from sun damage before treatment.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "results": {
            "heading": "Expected Results",
            "subheading": "",
            "para": "PowerShape delivers progressive improvements with each session:",
            "items": [
                {
                    "title": "Immediate Effects",
                    "desc": "Tighter, smoother skin and reduced puffiness after first session.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "After 2-4 Sessions",
                    "desc": "Visible fat reduction and improved body contours.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "Long-Term Maintenance",
                    "desc": "Sustained results with periodic treatments and healthy lifestyle.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "Cumulative Benefits",
                    "desc": "Continued collagen production enhances results over time.",
                    "icon": "fa-solid fa-layer-group"
                }
            ]
        },
        "aftercareTips": {
            "heading": "Aftercare Recommendations",
            "subheading": "",
            "para": "To maintain and enhance your PowerShape results:",
            "items": [
                {
                    "title": "Stay Hydrated",
                    "desc": "Continue drinking water to support detoxification and results.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "Maintain Activity",
                    "desc": "Regular exercise helps maintain your contoured results.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "Follow Treatment Plan",
                    "desc": "Complete the recommended session series for optimal outcomes.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "Healthy Diet",
                    "desc": "Balanced nutrition supports and prolongs your results.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "faqData": {
            "heading": "Frequently Asked Questions",
            "subheading": "",
            "items": [
                {
                    "question": "Is PowerShape painful?",
                    "answer": "Most patients find the treatment comfortable with only mild warmth from the RF energy."
                },
                {
                    "question": "How many sessions will I need?",
                    "answer": "Typically 4-6 sessions spaced 1-2 weeks apart for optimal results."
                },
                {
                    "question": "When will I see results?",
                    "answer": "Some improvements are visible immediately, with optimal results appearing 2-3 months after completing your sessions."
                },
                {
                    "question": "Are there any side effects?",
                    "answer": "Possible temporary redness or mild swelling that resolves quickly."
                },
                {
                    "question": "How long do results last?",
                    "answer": "Results are long-lasting with proper maintenance and healthy lifestyle habits."
                }
            ]
        }
    },
    "shared": {
        "images": {
            "main": "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/New-Service-Bansqs.jpg",
            "beforeAfter": [
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/09/WEIGHT-LOSS-2.jpg",
                    alt: "weight loss clinic in dubai",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/11/Cryolipolysis-services-in-dubai-eBH-3.jpg",
                    alt: "Cryolipolysis services in dubai eBH (3)",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2025/01/Before-After-Service-Images-1.jpg",
                    alt: "Before & After Service Images (1)",
                },
                {
                    src: "https://dev-elite.s3.me-central-1.amazonaws.com/wp-content/uploads/2024/10/Cryolipolysis-services-in-dubai-eBH-1.jpg",
                    alt: "Cryolipolysis services in dubai eBH (1)",
                },
            ]
        },
        "product": {
            "id": 167,
            "title": "PowerShape Body Contouring in Dubai",
            "description": "Non-invasive body sculpting combining RF, vacuum massage and foam therapy for fat reduction, cellulite improvement and skin tightening.",
            "price": 899
        }
    },
    "ar": {
        "url": "powershape-body-contouring",
        "meta": {
            "title": "جهاز باورشيب لنحت الجسم في دبي | ايليت بودي هوم",
            "description": "باورشيب هو علاج ثوري غير جراحي يجمع بين تقنيات متعددة لتنعيم السيلوليت، شد الجلد، وتقليل الدهون لتحسين تناسق الجسم.",
            "robots": "index, follow",
            "canonical": "https://www.elitebodyhome.com/services/powershape-body-contouring",
            "og": {
                "title": "جهاز باورشيب لنحت الجسم في دبي | ايليت بودي هوم",
                "description": "علاج غير جراحي لنحت الجسم يجمع بين الراديو فريكونسي، تدليك الفاكيوم والعلاج بالرغوة لتقليل الدهون وشد الجلد",
                "image": "https://www.elitebodyhome.com/images/powershape-og.jpg"
            }
        },
        "breadcrumbs": ["الرئيسية", "الخدمات", "باورشيب لنحت الجسم"],
        "hero": {
            "title": "علاج باورشيب لنحت الجسم في دبي",
            "subtitle": "تشكيل الجسم بتقنية ثلاثية الأبعاد",
            "description": "يُعد باورشيب علاجًا ثوريًا مصممًا لنحت الجسم وتحديد مظهره، حيث يعالج العديد من المشاكل في جلسة واحدة. يعمل بفعالية على تقليل السيلوليت، والدهون المتراكمة، وشد الجلد من خلال تقنية متكاملة. يتميز هذا العلاج بإنه إجراء غير جراحي وخالي من الألم، مما يجعله مناسبًا لجميع أنواع البشرة، ويُعد خيارًا مثاليًا لتحسين تناسق الجسم وإبراز ملامحه الجمالية مع تقديم نتائج طويلة الأمد."
        },
        "howItWorks": {
            "title": "كيف يعمل جهاز باورشيب؟",
            "description": "يعتمد باورشيب على ثلاث تقنيات متطورة تعمل بتناغم لتحقيق أفضل النتائج في نحت الجسم بدون جراحة أو تعاف."
        },
        "procedureSteps": {
            "heading": "خطوات العلاج",
            "para": "تتم جلسة باورشيب وفق الخطوات التالية:",
            "steps": [
                {
                    "title": "الاستشارة",
                    "desc": "تبدأ رحلتك مع استشارة شاملة لتقييم جسمك وتصميم خطة علاج مخصصة.",
                    "icon": "fa-solid fa-clipboard-question"
                },
                {
                    "title": "الراديو فريكونسي",
                    "desc": "تسخين طبقات الجلد العميقة لتحفيز الكولاجين وتدمير الخلايا الدهنية.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "التدليك بالفاكيوم",
                    "desc": "شفط متخصص لتحسين الدورة الدموية وتقليل مظهر السيلوليت.",
                    "icon": "fa-solid fa-hand-holding-medical"
                },
                {
                    "title": "العلاج بالرغوة",
                    "desc": "تقنية فقاعات الهواء لتفتيت الخلايا الدهنية للتخلص منها طبيعيًا.",
                    "icon": "fa-solid fa-wind"
                },
                {
                    "title": "العناية بعد الجلسة",
                    "desc": "تطبيق مستحضرات مهدئة لترطيب البشرة وإنعاشها.",
                    "icon": "fa-solid fa-spa"
                }
            ]
        },
        "benefits": {
            "heading": "فوائد باورشيب",
            "subheading": "نحت شامل للجسم بدون جراحة",
            "para": "يقدم باورشيب العديد من المزايا للراغبين في نحت الجسم غير الجراحي:",
            "items": [
                {
                    "title": "تقليل الدهون",
                    "desc": "استهداف تراكمات الدهون العنيدة في مناطق مثل البطن، الفخذين، الذراعين والأرداف.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "تحسين السيلوليت",
                    "desc": "تقليل مظهر الجلد المتعرج عن طريق تفتيت الأنسجة الدهنية.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "شد الجلد",
                    "desc": "تحفيز إنتاج الكولاجين والإيلاستين لبشرة أكثر تماسكًا وشبابًا.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "تحسين الدورة الدموية",
                    "desc": "تعزيز تدفق الدم والتصريف اللمفاوي.",
                    "icon": "fa-solid fa-heartbeat"
                },
                {
                    "title": "غير جراحي",
                    "desc": "لا حاجة لجراحة أو إبر أو فترة تعافي.",
                    "icon": "fa-solid fa-ban"
                },
                {
                    "title": "جلسات سريعة",
                    "desc": "تستغرق الجلسة فقط 30-60 دقيقة بدون وقت تعافي.",
                    "icon": "fa-solid fa-clock"
                }
            ]
        },
        "eligibility": {
            "heading": "من هو المرشح المناسب لباورشيب؟",
            "subheading": "",
            "para": "باورشيب مثالي للأفراد الذين يرغبون في تحسين تناسق الجسم بدون جراحة. أفضل المرشحين يشملون:",
            "items": [
                {
                    "title": "البالغين الأصحاء",
                    "desc": "من لديهم توقعات واقعية عن نحت الجسم غير الجراحي.",
                    "icon": "fa-solid fa-user"
                },
                {
                    "title": "الدهون الخفيفة إلى المتوسطة",
                    "desc": "الأشخاص الذين يعانون من تراكمات دهنية لا تستجيب للحمية والرياضة.",
                    "icon": "fa-solid fa-weight"
                },
                {
                    "title": "مشاكل السيلوليت",
                    "desc": "الراغبين في تقليل مظهر الجلد المتعرج.",
                    "icon": "fa-solid fa-spa"
                },
                {
                    "title": "ترهل الجلد",
                    "desc": "من يسعون لشد خفيف إلى متوسط للجلد.",
                    "icon": "fa-solid fa-leaf"
                },
                {
                    "title": "جميع أنواع البشرة",
                    "desc": "آمن وفعال لجميع ألوان وأنواع البشرة.",
                    "icon": "fa-solid fa-users"
                }
            ]
        },
        "preparationTips": {
            "heading": "الاستعداد لجلسة باورشيب",
            "subheading": "",
            "para": "لتحسين نتائج علاج باورشيب:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "اشرب كميات كافية من الماء قبل الجلسة لدعم التصريف اللمفاوي.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "وجبة خفيفة",
                    "desc": "تناول وجبة خفيفة وصحية قبل الجلسة للراحة.",
                    "icon": "fa-solid fa-utensils"
                },
                {
                    "title": "ملابس مريحة",
                    "desc": "اختر ملابس فضفاضة لسهولة الوصول لمناطق العلاج.",
                    "icon": "fa-solid fa-tshirt"
                },
                {
                    "title": "تجنب الشمس",
                    "desc": "احمِ بشرتك من أضرار الشمس قبل العلاج.",
                    "icon": "fa-solid fa-sun"
                }
            ]
        },
        "results": {
            "heading": "النتائج المتوقعة",
            "subheading": "",
            "para": "يقدم باورشيب تحسينات تدريجية مع كل جلسة:",
            "items": [
                {
                    "title": "نتائج فورية",
                    "desc": "بشرة مشدودة وناعمة مع تقليل الانتفاخ بعد الجلسة الأولى.",
                    "icon": "fa-solid fa-bolt"
                },
                {
                    "title": "بعد 2-4 جلسات",
                    "desc": "تقليل ملحوظ في الدهون وتحسن في تناسق الجسم.",
                    "icon": "fa-solid fa-chart-line"
                },
                {
                    "title": "نتائج طويلة الأمد",
                    "desc": "نتائج مستدامة مع جلسات دورية ونمط حياة صحي.",
                    "icon": "fa-solid fa-calendar-check"
                },
                {
                    "title": "فوائد تراكمية",
                    "desc": "استمرار إنتاج الكولاجين يعزز النتائج مع الوقت.",
                    "icon": "fa-solid fa-layer-group"
                }
            ]
        },
        "aftercareTips": {
            "heading": "نصائح ما بعد العلاج",
            "subheading": "",
            "para": "للحفاظ على نتائج باورشيب وتعزيزها:",
            "items": [
                {
                    "title": "الحفاظ على الترطيب",
                    "desc": "استمر في شرب الماء لدعم التخلص من السموم والنتائج.",
                    "icon": "fa-solid fa-glass-water"
                },
                {
                    "title": "النشاط البدني",
                    "desc": "التمارين المنتظمة تساعد في الحفاظ على النتائج.",
                    "icon": "fa-solid fa-running"
                },
                {
                    "title": "إكمال خطة العلاج",
                    "desc": "إكمال السلسلة الموصى بها من الجلسات للحصول على أفضل النتائج.",
                    "icon": "fa-solid fa-calendar-alt"
                },
                {
                    "title": "نظام غذائي صحي",
                    "desc": "التغذية المتوازنة تدعم وتطيل من نتائجك.",
                    "icon": "fa-solid fa-apple-alt"
                }
            ]
        },
        "faqData": {
            "heading": "الأسئلة الشائعة",
            "subheading": "",
            "items": [
                {
                    "question": "هل علاج باورشيب مؤلم؟",
                    "answer": "يجد معظم المرضى العلاج مريحًا مع شعور طفيف بالدفء من طاقة الراديو فريكونسي."
                },
                {
                    "question": "كم عدد الجلسات التي أحتاجها؟",
                    "answer": "عادةً 4-6 جلسات بفاصل 1-2 أسبوع للحصول على أفضل النتائج."
                },
                {
                    "question": "متى سأرى النتائج؟",
                    "answer": "تظهر بعض التحسينات فورًا، مع ظهور النتائج المثلى بعد 2-3 أشهر من إكمال الجلسات."
                },
                {
                    "question": "هل هناك أي آثار جانبية؟",
                    "answer": "احمرار مؤقت أو تورم خفيف يزول سريعًا."
                },
                {
                    "question": "كم تدوم النتائج؟",
                    "answer": "النتائج طويلة الأمد مع الصيانة المناسبة وعادات الحياة الصحية."
                }
            ]
        }
    }
}